module.exports = __webpack_public_path__ + "static/main-1b660c3846e4329d8976fdfca1717b03.png";